const SkeletonProfile = () => (
  <div className="animate-pulse space-y-8">
    {/* Profile Picture Skeleton */}
    <div className="flex flex-col items-center">
      <div className="rounded-full w-28 h-28 bg-gray-300"></div>
      <div className="w-32 h-4 mt-4 bg-gray-300 rounded"></div>
    </div>

    {/* Form Skeleton */}
    <div className="space-y-6">
      <div>
        <div className="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
        <div className="h-10 bg-gray-300 rounded w-full"></div>
      </div>
      <div>
        <div className="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
        <div className="h-10 bg-gray-300 rounded w-full"></div>
      </div>
      <div>
        <div className="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
        <div className="h-24 bg-gray-300 rounded w-full"></div>
      </div>
      <div className="h-12 bg-primary/20 rounded-lg"></div>
    </div>
  </div>
);
export default SkeletonProfile;
